import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PurityForm from '../../../../components/masters/styles/purity/PurityForm';
import PurityTable from '../../../../components/masters/styles/purity/PurityTable';
import { fetchPurities, addPurity, updatePurity, deletePurity, setPurityEdit, clearPurityEdit } from '../../../../redux/actions/masters/styles/purity/purityAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .purity-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .purity-form, .purity-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const PurityPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingPurity, formSuccess, formError } = useSelector(state => state.purity || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchPurities());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearPurityEdit());
  };

  const handleSubmit = async (form) => {
    if (editingPurity && editingPurity.id) {
      await dispatch(updatePurity(editingPurity.id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addPurity(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (purity) => {
    dispatch(setPurityEdit(purity));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deletePurity(id));
  };

  const handleCancel = () => {
    dispatch(clearPurityEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      p => p.purity_code === code && (!excludeId || p.id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="purity-flex">
        <div style={tableContainer} className="purity-table">
          <PurityTable
            onNew={handleFormReset}
            purities={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="purity-form">
          <PurityForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingPurity={editingPurity}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default PurityPage; 